import React from "react";
import { Loader2, Wand2 } from "lucide-react";
import { Panel } from "@/components/common/Panel";
import { TID } from "@/lib/testIds";

// Common SAP ACTVT values, for the optional Mass Generation field/ACTVT selector
const ACTVT_OPTIONS = [
    { code: "01", label: "Create" },
    { code: "02", label: "Change" },
    { code: "03", label: "Display" },
    { code: "06", label: "Delete" },
    { code: "16", label: "Execute" },
    { code: "43", label: "Release" },
];

export function MassGenerationPanel({
    specs, setSpecs, generating, generate, loadTemplate,
    showActvtSelector, setShowActvtSelector, defaultActvt, toggleDefaultActvt,
}) {
    return (
        <Panel eyebrow="Mass Role Generation" title="Generate roles from specifications" action={
            <button data-testid={TID.roleLoadTemplateBtn} onClick={loadTemplate} className="text-xs font-mono text-cyan-400 hover:text-cyan-300 transition-colors">
                Load template
            </button>
        }>
            <p className="text-xs text-slate-500 font-mono mb-2">
                One role per line — ROLE_NAME, TCODE1;TCODE2;…, [description]
            </p>
            <textarea
                data-testid={TID.roleGenerateInput}
                value={specs}
                onChange={(e) => setSpecs(e.target.value)}
                rows={6}
                placeholder={"Z_FI_AP_CLERK, FB60;MIRO;F-53, Accounts Payable Clerk\nZ_BASIS_SUPERUSER, SU01;PFCG;SE38;SE10, Basis Super User"}
                className="w-full bg-[var(--bg-base)] border border-white/10 rounded-sm px-3 py-2.5 text-sm font-mono text-slate-200 focus:border-cyan-500/40 focus:outline-none resize-y"
            />
            <div className="flex items-center justify-between mt-3 flex-wrap gap-2">
                <label className="inline-flex items-center gap-2 text-xs font-mono text-slate-400 cursor-pointer select-none">
                    <input
                        data-testid={TID.roleDefaultActvtToggle}
                        type="checkbox"
                        checked={showActvtSelector}
                        onChange={(e) => setShowActvtSelector(e.target.checked)}
                        className="accent-cyan-500"
                    />
                    Apply default ACTVT to every inferred object in this batch (field-verified SoD)
                </label>
            </div>
            {showActvtSelector && (
                <div className="mt-2 p-3 border border-cyan-500/20 bg-cyan-500/5 rounded-sm flex flex-wrap gap-3">
                    {ACTVT_OPTIONS.map((o) => (
                        <label key={o.code} className="inline-flex items-center gap-1.5 text-xs font-mono text-slate-300 cursor-pointer select-none">
                            <input
                                data-testid={TID.roleDefaultActvtCheckbox(o.code)}
                                type="checkbox"
                                checked={defaultActvt.has(o.code)}
                                onChange={() => toggleDefaultActvt(o.code)}
                                className="accent-cyan-500"
                            />
                            {o.code} · {o.label}
                        </label>
                    ))}
                </div>
            )}
            <div className="flex justify-end mt-3">
                <button
                    data-testid={TID.roleGenerateBtn}
                    onClick={generate}
                    disabled={generating}
                    className="btn-primary sheen inline-flex items-center gap-2 disabled:opacity-60"
                >
                    {generating ? <Loader2 size={15} className="animate-spin" /> : <Wand2 size={15} />}
                    {generating ? "Generating…" : "Generate & Validate"}
                </button>
            </div>
        </Panel>
    );
}
